import { render, staticRenderFns } from "./TaskEditor.vue?vue&type=template&id=cf47c6e6&"
import script from "./TaskEditor.vue?vue&type=script&lang=js&"
export * from "./TaskEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports